import * as S from "./bottomSheetHeader.styles";

const BottomSheetHeader = () => {
  return (
    <S.Wrapper>
      <S.Handle />
    </S.Wrapper>
  );
};

export default BottomSheetHeader;
